import { inject } from '@angular/core';
import { NavigationService } from 'app/core/navigation/navigation.service';
import { MessagesService } from 'app/layout/common/messages/messages.service';
import { NotificationsService } from 'app/layout/common/notifications/notifications.service';
import { QuickChatService } from 'app/layout/common/quick-chat/quick-chat.service';
import { ShortcutsService } from 'app/layout/common/shortcuts/shortcuts.service';
import { PermissionService } from '@core/permission/permission.service';
import { catchError, forkJoin, of } from 'rxjs';

export const initialDataResolver = () => {
    const messagesService = inject(MessagesService);
    const navigationService = inject(NavigationService);
    const notificationsService = inject(NotificationsService);
    const quickChatService = inject(QuickChatService);
    const shortcutsService = inject(ShortcutsService);

    const permissionsService = inject(PermissionService);

    // Read data does not depend on the provisional permission catalog.
    // Load it alongside the page data for the remaining write-action checks.
    return forkJoin([
        navigationService.get(),
        messagesService.getAll(),
        notificationsService.getAll(),
        quickChatService.getChats(),
        shortcutsService.getAll(),
        permissionsService.ensureAuthorizationContextLoaded().pipe(
            catchError(() => {
                permissionsService.clear();
                return of(null);
            })
        ),
    ]);
};
